module.exports = __webpack_public_path__ + "static/media/feedback-best.b739593e.png";